/*
 * @Author: Tommy Chen weiyao_85@163.com
 * @Date: 2025-01-23 16:37:19
 * @LastEditors: Tommy Chen weiyao_85@163.com
 * @LastEditTime: 2025-07-15 16:59:55
 * @FilePath: /help.center.intl/src/utils/zhuge.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
(function () {
    window.zhuge = window.zhuge || [];
    window.zhuge.methods = '_init identify track getDid getSid getKey setSuperProperty setUserProperties setWxProperties setPlatform'.split(
      ' '
    );
    window.zhuge.factory = function (b) {
      return function () {
        var a = Array.prototype.slice.call(arguments);
        a.unshift(b);
        window.zhuge.push(a);
        return window.zhuge;
      };
    };
    

    for (var i = 0; i < window.zhuge.methods.length; i++) {
      var key = window.zhuge.methods[i];
      window.zhuge[key] = window.zhuge.factory(key);
    }
    window.zhuge.load = function (b, x) {
    };
    window.zhuge.load('14ae611dcfbc4b6cb95a71e0cac6cf0b', {
      //配置应用的AppKey
      superProperty: {
        //全局的事件属性(选填)
        应用名称: '诸葛io',
      },
      adTrack: false, //广告监测开关，默认为false
      autoTrack: true,
      //启用全埋点采集（选填，默认false）
      singlePage: false, //是否是单页面应用（SPA），启用autoTrack后生效（选填，默认false）
      updateUtm: true,
    //   debug: true,
    });
  })();
  